<template>
  <div class="diffusionAnalysis" v-if="diffusionAnalysisDeviceInfoCom?.deviceNo">
    <i></i>
    <p>
      {{diffusionAnalysisDeviceInfoCom.desc}}
    </p>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      timer: null,
    };
  },
  //计算属性 类似于data概念
  computed: {
    diffusionAnalysisDeviceInfoCom() {
      return this.$store.state.diffusionAnalysisDeviceInfo;
    },
  },
  //监控data中的数据变化
  watch: {
    diffusionAnalysisDeviceInfoCom(newVal, oldVal) {
      console.log("new", newVal, oldVal);
      if (newVal?.deviceNo) {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.close();
          this.closeAllColor();
        }, 5 * 1000);
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: {
    close() {
      this.$store.commit("changeDiffusionAnalysisDeviceInfo", {});
    },
    closeAllColor() {
     window.currentODlineArr =
            window.currentODlineArr && window.currentODlineArr.destroy();
      let buildGroup =
        g_bme3dManager?.earth?.sceneTree?.$refs?.bgPower?.children;
      buildGroup &&
        buildGroup.forEach((item) => {
          item.enabled = false;
        });
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
.diffusionAnalysis {
  width: 800px;
  min-height: 42px;
  pointer-events: all;
  position: absolute;
  right: 700px;
  top: 180px;
  background: url("./../img/warnbg.png") no-repeat;
  background-size: 100% 100%;
  padding: 10px 50px;
  display: flex;
  align-items: center;
  i {
    background: url("./../img/warnIcon.png") no-repeat;
    background-size: 100% 100%;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    display: inline-block;
    margin-right: 10px;
  }
}
</style>